module.exports = __webpack_public_path__ + "static/img/5.d6ca57fb.png";